import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const AlertIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M12 5.33334C12 4.27248 11.5786 3.25506 10.8284 2.50492C10.0783 1.75477 9.06087 1.33334 8 1.33334C6.93913 1.33334 5.92172 1.75477 5.17157 2.50492C4.42143 3.25506 4 4.27248 4 5.33334C4 8.1865 3.2524 9.79366 2.67136 10.6119C2.4995 10.8539 2.69401 11.3333 2.99083 11.3333H13.0092C13.306 11.3333 13.5005 10.8539 13.3286 10.6119C12.7476 9.79366 12 8.1865 12 5.33334Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M9.15335 14C9.03614 14.2021 8.86791 14.3698 8.6655 14.4864C8.46309 14.6029 8.2336 14.6643 8.00001 14.6643C7.76643 14.6643 7.53694 14.6029 7.33453 14.4864C7.13212 14.3698 6.96389 14.2021 6.84668 14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M13.7128 1.12543C13.9496 1.22844 14.1713 1.40794 14.3558 1.64595C14.5403 1.88397 14.681 2.17216 14.7639 2.48166C14.8469 2.79116 14.8691 3.11112 14.8283 3.40949C14.7876 3.70785 14.6853 3.97417 14.5317 4.18176"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2.23291 1.14677C1.99618 1.24957 1.77453 1.42878 1.59015 1.66645C1.40577 1.90411 1.26513 2.1919 1.1823 2.501C1.09948 2.8101 1.07739 3.12965 1.11823 3.42767C1.15908 3.72568 1.26143 3.99171 1.41504 4.1991"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
